import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import { selectLayerDataSet } from "../../../features/layers/overlaylayerslice";
import { useSelector } from "react-redux";

const Legend = () => {
  const map = useMap();
  const layerData = useSelector(selectLayerDataSet);

  useEffect(() => {
    let colors, Actualvalues, units, val;

    // Remove existing legends
    const removeLegends = () => {
      map.eachLayer((layer) => {
        if (
          layer._control &&
          layer._control.getContainer &&
          layer._control.getContainer().classList.contains("leaflet-legend")
        ) {
          map.removeControl(layer._control);
        }
      });
    };

    removeLegends();

    layerData.forEach((overlayer) => {
      console.log(overlayer)
      const dataType = overlayer.datatype?.toLowerCase();

      if (
        overlayer.show &&
        overlayer.class === "Model" &&
        (dataType === "temperature" || dataType === "wind")
      ) {
        const legendData = overlayer.legend[overlayer.datatype];
        colors = legendData[overlayer.altitude].colorBar;
        Actualvalues = legendData[overlayer.altitude].range;
        units = legendData.units;
        val = dataType;
      }

      if (
        overlayer.show &&
        overlayer.class === "Model" &&
        (dataType === "rainfall" || dataType === "acurain" || dataType === "humidity" || dataType === "wbgt" )
      ) {
        console.log(overlayer.legend)
        const legendData = overlayer.legend[overlayer.datatype];
        colors = legendData.colorBar;
        Actualvalues = legendData.range;
        units = legendData.units;
        val = dataType;
      }
    });

    if (colors && Actualvalues) {
      const values = Actualvalues;

      const legend = L.control({ position: "bottomright" });
      legend.onAdd = function () {
        const div = L.DomUtil.create("div", "leaflet-legend");
        
        // Responsive styles
        const isMobile = window.innerWidth <= 768;
        const height = isMobile ? "24px" : "3vh";
        const minHeight = isMobile ? "24px" : "28px";
        const fontSize = isMobile ? "0.6rem" : "0.7rem";
        const bottomPosition = isMobile ? "2px" : "2px";

        div.innerHTML = `
          <div style="
            display: flex;
            position: relative;
            align-items: center;
            height: ${height};
            min-height: ${minHeight};
            width: 90vw;
            max-width: 450px;
            overflow: hidden;
            border-radius: 10px;
            top: -100px;
            box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
          ">
            ${colors
              .map(
                (color, i) => `
                <div style="
                  height: 100%; 
                  flex: 1; 
                  background-color: ${color};
                  position: relative;
                  ${i === 0 ? "border-top-left-radius: 10px; border-bottom-left-radius: 10px;" : ""}
                  ${i === colors.length - 1 ? "border-top-right-radius: 10px; border-bottom-right-radius: 10px;" : ""}
                ">
                  <span style="
                    position: absolute;
                    bottom: ${bottomPosition};
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: ${fontSize};
                    color: ${["wind", "acurain", "rainfall"].includes(val) ? "#000" : "#fff"};
                    white-space: nowrap;
                    text-shadow: ${["wind", "acurain", "rainfall"].includes(val) 
                      ? "1px 1px 1px rgba(255,255,255,0.5)" 
                      : "1px 1px 1px rgba(0,0,0,0.5)"};
                  ">${i === 0 ? units : Math.round(values[i + 1])}</span>
                </div>`
              )
              .join("")}
          </div>
        `;
        return div;
      };
      legend.addTo(map);

      return () => {
        map.removeControl(legend);
      };
    }

    return () => {
      removeLegends();
    };
  }, [map, layerData]);

  return null;
};

export default Legend;